//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'
import { mapGetters, mapActions } from 'vuex'
import { axiosGet, axiosPost } from '../../../axios/axios.js'
import { EventBus } from '../../../EventBus/EventBus.js'
import { convertRequestPriority, convertTime, ALARM_SEVERITIES_CONFIG } from '../../../components/helpers.js'
import {
  convertRequestFromServer,
  convertRequestToServer,
  getRequestRoles,
  REQUEST_PRIORITIES
} from '../../../forms/Request/Request.js'
import { requestActions } from '../RequestActions.js'

import RequestAutoPriority from '../../../forms/Request/RequestAutoPriority.vue'
import FilesField from '../../../components/File/FilesField.vue'
import FilesGroup from '../../../components/File/FilesGroup.js'
import Comments from '../../../components/Comments/Comments.vue'
import RequestPriorityField from '../RequestPriorityField.vue'
import RequestRedirectedWorkAreaField from '../RequestRedirectedWorkAreaField.vue'
import RequestAutoAssignItem from '../RequestAutoAssignItem.vue'
import RequestForkliftTruckField from '../RequestForkliftTruckField.vue'
import RequestWorksSimpleSection from '../RequestWorksSimpleSection.vue'
import RequestMapPopupExecutor from './RequestMapPopupExecutor.vue'
import RequestMapPopupTaskButtons from './RequestMapPopupTaskButtons.vue'
import RequestAdjacentObjectsRequests from '../RequestAdjacentObjectsRequests.vue'
import DateTimeField from '../../../components/Field/DateTimeField.vue'

export default {
  name: 'RequestMapPopup',
  components: {
    RequestMapPopupExecutor,
    RequestMapPopupTaskButtons,
    RequestPriorityField,
    RequestRedirectedWorkAreaField,
    RequestAutoAssignItem,
    RequestForkliftTruckField,
    RequestWorksSimpleSection,
    FilesField,
    Comments,
    RequestAutoPriority,
    DateTimeField
  },
  mixins: [requestActions],
  props: {
    requestId: {
      type: Number,
      default: null
    },
    inputRequest: {
      type: Object,
      default: null
    },
    showCloseRequests: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      request: null,
      requestInitial: null,
      loading: false,
      forbidden: false,
      requestRoles: null,
      currentRequestTypes: [],
      requestPriorities: REQUEST_PRIORITIES,
      expandedComments: true,
      expandedPhotos: false,
      expandedFiles: false,
      expandedTechnicalTasksFiles: false,
      collapsePanel: [],
      selectedImageIndex: null,
      convertTime: convertTime,
      selectedTab: this.$store.getters.getRequestPopupTab || 'generalInfo'
    }
  },
  computed: {
    ...mapGetters({
      requestTypes: 'getRequestTypes',
      requestSources: 'getRequestSources',
      taskStatesColors: 'getTaskStatesColors',
      requestTypesColors: 'getRequestTypesColors',
      reportStateColors: 'getReportStateColors',
      reportStateTextColors: 'getReportStateTextColors'
    }),
    user: function () {
      return this.$store.getters.getUser
    },
    serviceObjectName: function () {
      let serviceObjectName = this.request.serviceObjectName ? this.request.serviceObjectName.replace(' №', '') : ''
      if (!serviceObjectName && this.request.beaconMountingPointZoneIds && this.request.beaconMountingPointZoneIds.length > 0) {
        serviceObjectName = this.request.beaconMountingPointZoneIds.join(', ')
      }
      return serviceObjectName
    },
    hasEditAccess: function () {
      return this.requestRoles.hasEditAccess
    },
    externalDispatcherBounded: function () {
      const user = this.$store.getters.getUser
      return user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')
    },
    displayPriorityField: function () {
      return !this.externalDispatcherBounded
    },
    displaySaveChangesButton: function () {
      return !this.request.hasProposedExecutor && this.hasEditAccess
    },
    displaySaveChangesAndSetExecutorButton: function () {
      if (this.request.hasProposedExecutor) {
        return this.requestRoles.executorChangeAvailable || this.requestRoles.reinforcementExecutorChangeAvailable
      }
      return false
    },
    closeConditionTimeClass: function () {
      if (this.request && this.request.createTime && this.request.closeConditionTime) {
        const timeLeft = this.request.closeConditionTime - new Date().getTime()
        if (timeLeft <= 0) {
          return 'task-fire'
        }
        const fullTime = this.request.closeConditionTime - this.request.createTime
        const precentage = (timeLeft / fullTime) * 100
        if (precentage <= 5) {
          return 'task-fire'
        } else if (precentage <= 20) {
          return 'task-warn'
        }
      }
      return ''
    },
    autoAssignStartTimeStr: {
      get: function () {
        if (this.request && this.request.autoAssignStartTime) {
          return this.formatMillis(this.request.autoAssignStartTime)
        } else {
          return null
        }
      },
      set: function (newValue) {
        if (newValue) {
          this.request.autoAssignStartTime = this.parseMillis(newValue)
        } else {
          this.request.autoAssignStartTime = null
        }
      }
    },
    showReportStateWarning: function () {
      return !!(this.request && this.request.reportState === 'PR11')
    },
    reportStateColor: function () {
      const stateId = this.request.reportState
      return this.reportStateColors && stateId && this.reportStateColors[stateId] || null
    },
    reportStateTextColor: function () {
      const stateId = this.request.reportState
      return this.reportStateTextColors && stateId && this.reportStateTextColors[stateId] || null
    },
    reportStateLabelStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold; margin-left: 4px; padding: 0 4px;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    },
    reportStateBadgeStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    }
  },
  watch: {
    selectedTab: function (value) {
      this.$store.dispatch('setRequestPopupTab', value)
    },
    requestId: function () {
      this.setSelectedRequestPopup(null)
      if (this.requestId && !this.inputRequest) {
        this.loadRequest()
      }
    }
  },
  created: async function () {
    if (this.inputRequest) {
      this.prepareRequest(this.inputRequest)
    } else {
      this.loadRequest()
    }
  },
  beforeDestroy: function () {
    this.setSelectedRequestPopup(null)
  },
  methods: {
    ...mapActions({
      setSelectedRequestPopup: 'setSelectedRequestPopup'
    }),
    openIpAddress: function () {
      if (this.request.serviceObject.deviceIp && this.request.serviceObject.deviceIp !== 'Нет данных') {
        window.open('http://' + this.request.serviceObject.deviceIp.split(', ')[0])
      }
    },
    getPriorityColor: function (value) {
      const formattedValue = convertRequestPriority(value)

      if (formattedValue === 'Низкий') {
        return 'light-blue-1'
      } else if (formattedValue === 'Средний') {
        return 'warning'
      } else {
        return 'negative'
      }
    },
    getPriorityTooltipText: function (value) {
      const formattedValue = convertRequestPriority(value)

      if (formattedValue === 'Низкий') {
        return 'Заявка с низким приоритетом'
      } else if (formattedValue === 'Средний') {
        return 'Заявка со средним приоритетом'
      } else if (formattedValue === 'Высокий') {
        return 'Заявка с высоким приоритетом'
      } else if (formattedValue === 'Срочно') {
        return 'Заявка со срочным приоритетом'
      } else if (formattedValue === 'Критический') {
        return 'Заявка с критическим приоритетом'
      }
    },
    isImage: function (str) {
      return str != null && str.startsWith('image/')
    },
    loadRequest: function () {
      const id = this.requestId || this.request.requestId
      if (id) {
        this.loading = true
        this.$emit('start-loading')

        axiosGet({
          url: '/service/delta/request/getRequest?id=' + this.requestId,
          onSuccess: (response) => {
            const requestData = response.data.result
            this.prepareRequest(requestData)

            if (this.forbidden) {
              this.forbidden = false
            }
          },
          onFailure: (response) => {
            const message = response.message || 'Ошибка загрузки информации по заявке'
            this.$q.notify({
              type: 'negative',
              message: message,
              progress: true,
              timeout: 5000
            })

            if (response.code === 'forbidden') {
              this.forbidden = true
              this.request = null
              this.requestRoles = {}
            }
          }
        }).finally(() => {
          this.$emit('end-loading')
          this.$emit('update', this.request)
          this.loading = false
        })
      }
    },
    prepareRequest: function (requestData) {
      const request = convertRequestFromServer(requestData, this.user)
      this.requestInitial = convertRequestFromServer(JSON.parse(JSON.stringify(requestData, this.user)))
      request.initialObject = this.requestInitial

      const photosFilesGroup = new FilesGroup({
        key: 'images',
        categoryKey: 'dispatcher',
        enrichmentFn: function (document) {
          return {
            name: request.name + '-' + this.files.length + '.' + document.contentType.split('/')[1] // TODO FileDocument - name
          }
        },
        readonly: true
      })
      request.images = photosFilesGroup

      const filesGroup = new FilesGroup({
        key: 'files',
        categoryKey: 'dispatcher',
        readonly: true
      })
      request.files = filesGroup

      const documents = request.documents
      if (documents) {
        documents.forEach(document => {
          if (this.isImage(document.contentType) && document.category !== 'files') {
            photosFilesGroup.pushFile(document)
          } else if (document.category === 'files') {
            filesGroup.pushFile(document)
          }
        })
        if (request.files.files.length) {
          this.expandedFiles = true
        }
        if (request.images.files.length) {
          this.expandedPhotos = true
        }
      }

      const technicalTasksFilesGroup = new FilesGroup({
        key: 'files',
        categoryKey: 'dispatcher',
        readonly: true
      })

      request.technicalTasksFiles = technicalTasksFilesGroup
      if (request.technicalTasks && request.technicalTasks.length) {
        request.technicalTasks.forEach(document => {
          technicalTasksFilesGroup.pushFile(document)
        })
        if (request.technicalTasksFiles.files.length) {
          this.expandedTechnicalTasksFiles = true
        }
      }

      if (request.serviceObject) {
        if (!request.serviceObject.deviceIp) {
          request.serviceObject.deviceIp = '0.0.0.0'
        }
      }

      this.request = request
      this.setSelectedRequestPopup(request)

      this.requestRoles = getRequestRoles(this.request, this.user, 'popup')
      this.setCurrentRequestTypes()
    },
    setCurrentRequestTypes: function () {
      if (this.request && this.request.serviceObjectType && this.requestTypes) {
        this.currentRequestTypes = []

        for (let i = 0; i < this.requestTypes.length; i++) {
          if (this.requestTypes[i].serviceObjectType) {
            const serviceObjectType = this.requestTypes[i].serviceObjectType

            for (let j = 0; j < serviceObjectType.length; j++) {
              if (serviceObjectType[j].key === this.request.serviceObjectType) {
                this.currentRequestTypes.push(this.requestTypes[i])
              }
            }
          }
        }
      } else {
        this.currentRequestTypes = this.requestTypes
      }
    },
    getTaskStateColor: function () {
      if (this.request.bpStateId && this.taskStatesColors && this.taskStatesColors[this.request.bpStateId]) {
        return this.taskStatesColors[this.request.bpStateId]
      } else {
        return 'white'
      }
    },
    getRequestTypeColor: function () {
      if (this.request.requestTypeKey && this.requestTypesColors && this.requestTypesColors[this.request.requestTypeKey]) {
        return this.requestTypesColors[this.request.requestTypeKey]
      } else {
        return 'background-color: white;'
      }
    },
    openAddressInYandexMaps: function () {
      const url = this.$d.getYandexMapsLocationUrl(this.request.location)
      window.open(url)
    },
    getAlarmConfig: function (severityKey) {
      return ALARM_SEVERITIES_CONFIG[severityKey] || {}
    },
    changePBState: function (state, props, callback) {
      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('objectId', this.request.bpContextId)

      if (props != null) {
        bodyFormData.set('props', JSON.stringify(props))
      }

      axiosPost({
        url: '/service/delta/requestBusinessProcess/' + state,
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Статус задания успешно изменен',
            progress: true,
            timeout: 1500
          })

          !!callback && callback()
          this.loadRequest()
          EventBus.$emit('update-request', { savePage: true, saveScroll: true })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })

          !!callback && callback(new Error(response.message))
          this.loading = false
        }
      })
    },
    onBPStateChanged: function () {
      this.loadRequest()
      EventBus.$emit('update-request', { savePage: true, saveScroll: true })
    },
    saveTaskChanges: async function (assignTaskToExecutor = true) {
      this.loading = true

      if (!(await this.isTaskValid())) {
        this.loading = false
        return
      }

      let bpMoveProps = null
      if (assignTaskToExecutor) {
        const bpMoveInfo = await this.checkBPMove()
        bpMoveProps = bpMoveInfo.props
        if (!bpMoveInfo.confirmed) {
          this.loading = false
          return
        }
      }

      const tempRequest = convertRequestToServer(this.request, false, this.requestInitial)
      const tempRequestStr = JSON.stringify(tempRequest)
      const bodyFormData = new FormData()
      bodyFormData.set('requestId', this.request.requestId)
      bodyFormData.set('properties', tempRequestStr)

      axiosPost({
        url: '/service/delta/request/edit',
        data: bodyFormData,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Изменения по заявке сохранены',
            progress: true,
            timeout: 3000
          })

          if (!assignTaskToExecutor) {
            this.loadRequest()
            EventBus.$emit('update-request', { savePage: true, saveScroll: true })
          } else {
            this.assignTaskToExecutorWithBPMove(this.request.requestId, bpMoveProps, (error, result) => {
              if (!error) {
                this.loadRequest()
              } else {
                this.loading = false
              }
              EventBus.$emit('update-request', { savePage: true, saveScroll: true })
            })
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })

          this.loading = false
        }
      })
    },
    onAddComment: function () {
      this.$refs.comments.onAddComment(() => {
        this.expandedComments = true
      })
    },
    onShowRecentRequests: function () {
      this.$emit('select', this.request)
    },
    formatMillis: function (millis) {
      console.log()
      if (millis) {
        return date.formatDate(millis, 'DD.MM.YYYY HH:mm')
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, 'DD.MM.YYYY HH:mm')
    },
    parseMillis (value) {
      return this.parseDate(value).getTime()
    },
    showAdjacentObjectsRequests: function () {
      const dialog = this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerLabel: 'Заявки на объектах, смежных с ' + this.serviceObjectName,
        contentComponent: RequestAdjacentObjectsRequests,
        contentProps: {
          requestId: this.request.requestId,
          objectId: this.request.serviceObjectId,
          objectType: this.request.serviceObjectType
        },
        componentHandlers: {
          close: () => {
            dialog.hide()
          }
        }
      })
    }
  }
}

